import React from "react"
import {colors} from "@indebted/theme"

const variants = {
	inline: Inline,
	square: Square,
}

function InDebted({variant, width = "100%", brandColor = colors.freshBlue, textColor = colors.darkGrey}) {
	const Variant = variants[variant]
	return <Variant width={width} brandColor={brandColor} textColor={textColor} />
}

function Inline({width, brandColor, textColor}) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			xmlSpace="preserve"
			version="1.1"
			width={width}
			viewBox="0 0 5312 859"
			shapeRendering="geometricPrecision"
			textRendering="geometricPrecision"
			imageRendering="optimizeQuality"
			fillRule="evenodd"
			clipRule="evenodd"
		>
			<path
				fill={brandColor}
				fillRule="nonzero"
				d="M927 655l1 1c3,4 6,7 11,9l0 0c3,2 8,3 12,3l526 0c5,0 9,-1 13,-3 4,-2 7,-5 11,-9l0 0c3,-4 6,-8 8,-13l0 0c1,-6 2,-11 2,-17 0,-6 -1,-12 -2,-17l0 0c-2,-5 -5,-9 -8,-13l0 0c-4,-4 -7,-7 -11,-9 -4,-2 -8,-3 -13,-3l-526 0c-4,0 -9,1 -12,3l0 0c-5,2 -8,5 -11,9l-1 1c-3,3 -6,8 -7,12 -2,5 -3,11 -3,17 0,6 1,11 3,17 1,4 4,9 7,12zm244 -552c3,4 8,7 13,9 5,2 10,3 16,3l298 0c22,0 43,3 64,7 21,4 42,10 61,18 20,9 39,19 57,31 18,12 34,25 49,41l0 0c16,15 29,31 41,49 12,18 22,37 31,57 8,19 14,40 18,61 4,21 7,42 7,64 0,21 -3,43 -7,63 -4,21 -10,42 -18,61 -9,20 -19,39 -31,57 -12,18 -25,35 -41,50l0 0c-15,15 -31,29 -49,41 -18,11 -37,22 -57,30 -19,8 -40,14 -61,19 -21,4 -42,6 -64,6l-394 0c-6,0 -11,1 -16,3 -5,2 -10,5 -14,9 -4,4 -7,9 -9,14 -2,4 -3,10 -3,16 0,5 1,11 3,16 2,5 5,9 9,13l1 1c4,3 8,6 13,8 5,2 10,3 16,3l394 0c28,0 55,-2 80,-8 27,-5 53,-13 77,-23 25,-10 49,-23 71,-38 22,-15 43,-32 62,-51 20,-19 37,-40 52,-63 15,-22 28,-46 38,-71 10,-24 18,-50 23,-76 5,-26 8,-53 8,-80 0,-28 -3,-55 -8,-80 -5,-27 -13,-53 -23,-77 -10,-25 -23,-49 -38,-71 -15,-22 -32,-43 -51,-62l0 0c-20,-20 -41,-37 -63,-52 -22,-15 -46,-27 -71,-38 -24,-10 -50,-18 -77,-23 -25,-5 -52,-8 -80,-8l-298 0c-6,0 -11,1 -16,3 -5,2 -10,5 -13,9l0 0c-8,8 -13,18 -13,30 0,5 2,11 4,16 2,5 5,9 9,13l0 0zm-243 370c3,4 7,6 11,8l0 0c3,2 8,3 12,3l535 0c4,0 8,-1 12,-3 4,-1 8,-4 11,-8l1 -1c3,-4 5,-8 7,-13 2,-5 3,-10 3,-16 0,-6 -1,-12 -3,-17 -2,-5 -4,-9 -7,-12l-1 -2c-3,-3 -7,-6 -11,-8l0 0c-4,-2 -8,-3 -12,-3l-535 0c-4,0 -9,1 -12,3l0 0c-5,2 -8,5 -11,8l0 0c-4,4 -7,9 -8,14l0 0c-2,5 -3,11 -3,17 0,6 1,11 3,16 2,5 4,10 8,14l0 0zm1 -184l1 1c3,3 7,6 11,8l0 0c4,2 8,3 12,3l530 0c5,0 9,-1 13,-3l0 0c4,-2 8,-5 11,-8l1 -1c3,-4 5,-8 7,-13 2,-5 3,-11 3,-17 0,-6 -1,-11 -3,-16 -2,-5 -4,-9 -7,-13l-1 -1c-3,-4 -7,-7 -11,-9l0 0c-4,-1 -8,-2 -13,-2l-530 0c-4,0 -8,1 -12,2l0 0c-4,2 -8,5 -11,9l-1 1c-3,3 -5,8 -7,13l0 0c-2,5 -3,10 -3,16 0,6 1,12 3,17 2,5 4,9 7,13z"
			/>
			<polygon fill={textColor} fillRule="nonzero" points="0,34 82,34 82,857 0,857 " />
			<path
				fill={textColor}
				fillRule="nonzero"
				d="M247 859l79 0 0 -284c0,-70 3,-117 11,-143 11,-38 32,-67 64,-89 31,-21 69,-32 113,-32 43,0 80,10 111,31 30,22 51,49 62,84 9,23 13,73 13,149l0 284 80 0 0 -299c0,-84 -10,-147 -30,-190 -20,-42 -49,-75 -89,-99 -39,-24 -88,-36 -147,-36 -60,0 -109,12 -149,36 -40,24 -69,57 -89,100 -19,44 -29,108 -29,195l0 293z"
			/>
			<path
				fill={textColor}
				d="M2636 706c-17,29 -37,54 -59,74 -28,26 -60,45 -96,59 -35,13 -75,20 -120,20 -99,0 -177,-32 -233,-97 -55,-65 -83,-139 -83,-220 0,-78 23,-146 71,-207 60,-77 140,-115 241,-115 103,0 186,39 248,118 44,55 66,125 67,208l-547 0c1,71 24,129 68,174 43,45 97,68 161,68 31,0 62,-5 91,-16 29,-11 54,-26 74,-43 16,-14 32,-34 50,-60l67 37zm-50 -228c-10,-42 -25,-75 -45,-100 -20,-25 -47,-45 -80,-60 -33,-16 -67,-23 -103,-23 -60,0 -111,19 -154,57 -31,29 -55,70 -71,126l453 0z"
			/>
			<path
				fill={textColor}
				fillRule="nonzero"
				d="M2867 740c-34,-55 -54,-110 -60,-163 0,-386 0,-578 0,-577l77 0 0 340c33,-41 70,-71 111,-91 40,-19 85,-29 134,-29 85,0 159,31 220,93 61,63 91,139 91,228 0,88 -30,163 -92,225 -61,62 -135,93 -222,93 -49,0 -96,-9 -139,-29 -44,-19 -84,-49 -120,-90zm253 44c44,0 84,-11 121,-32 37,-22 66,-52 88,-91 22,-38 33,-79 33,-123 0,-43 -11,-84 -33,-123 -22,-40 -52,-70 -89,-92 -37,-21 -77,-32 -119,-32 -43,0 -84,11 -122,32 -39,22 -68,51 -89,88 -21,38 -31,79 -31,125 0,71 23,130 70,177 46,47 103,71 171,71z"
			/>
			<path
				fill={textColor}
				fillRule="nonzero"
				d="M3817 772c-39,21 -77,23 -114,5 -45,-34 -66,-83 -64,-147l0 -257 201 0 0 -67 -202 0 0 -294 -78 0 0 632c-1,44 9,85 30,122 35,59 82,90 142,93 32,1 68,-6 109,-22 -6,-15 -14,-37 -24,-65z"
			/>
			<path
				fill={textColor}
				fillRule="nonzero"
				d="M5252 740c33,-55 53,-110 60,-163 0,-386 0,-578 0,-577l-78 0 0 340c-33,-41 -70,-71 -110,-91 -41,-19 -86,-29 -134,-29 -86,0 -159,31 -220,93 -62,63 -92,139 -92,228 0,88 31,163 92,225 62,62 136,93 222,93 50,0 96,-9 140,-29 43,-19 83,-49 120,-90zm-253 44c-44,0 -85,-11 -121,-32 -37,-22 -67,-52 -88,-91 -22,-38 -33,-79 -33,-123 0,-43 11,-84 33,-123 22,-40 51,-70 89,-92 37,-21 76,-32 119,-32 43,0 83,11 122,32 38,22 68,51 89,88 20,38 31,79 31,125 0,71 -24,130 -70,177 -47,47 -104,71 -171,71z"
			/>
			<path
				fill={textColor}
				d="M4526 706c-17,29 -37,54 -59,74 -28,26 -60,45 -96,59 -35,13 -75,20 -120,20 -99,0 -177,-32 -232,-97 -56,-65 -84,-139 -84,-220 0,-78 24,-146 71,-207 60,-77 140,-115 241,-115 103,0 186,39 248,118 44,55 66,125 67,208l-547 0c2,71 24,129 68,174 44,45 98,68 162,68 31,0 61,-5 90,-16 29,-11 54,-26 75,-43 15,-14 32,-34 49,-60l67 37zm-50 -228c-10,-42 -25,-75 -45,-100 -20,-25 -46,-45 -79,-60 -33,-16 -68,-23 -104,-23 -60,0 -111,19 -154,57 -31,29 -55,70 -71,126l453 0z"
			/>
		</svg>
	)
}

function Square({width, brandColor}) {
	return (
		<svg width={width} viewBox="0 0 271 226" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M78 12H158.464C214.245 12 259.464 57.2192 259.464 113C259.464 168.781 214.245 214 158.464 214H51.5"
				stroke={brandColor}
				strokeWidth="23"
				strokeLinecap="round"
			/>
			<path d="M12 63L152 63" stroke={brandColor} strokeWidth="23" strokeLinecap="round" />
			<path d="M12 113L152 113" stroke={brandColor} strokeWidth="23" strokeLinecap="round" />
			<path d="M12 163L152 163" stroke={brandColor} strokeWidth="23" strokeLinecap="round" />
		</svg>
	)
}

export {InDebted}
